export const GDA_ITEMS_PER_PAGE = 30;

export type GuaranteesListState = {
  page?: number;
  searchText?: string;
  activeFilters?: Record<string, string>;
  companyName?: string;
};
